import { Box, Typography } from "@mui/material";
import ElDefectsForm from "../../components/common/form/ElDefectsForm";
import { DefectCounter } from "../../components/ui/buttons/DefectCounter";
import { DefectType } from "../../types/stringerTypes";

export default function ElDefectTrackingPage() {
  const renderCounter = (
    defect: DefectType,
    count: number,
    onChange: (delta: number) => void
  ) => <DefectCounter label={defect} count={count} onChange={onChange} />;

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        EL-Defekt-Erfassung
      </Typography>
      <ElDefectsForm renderCounter={renderCounter} />
    </Box>
  );
}
